import { IconButton, styled, Typography } from '@mui/material';

import { Colors } from 'Themes/colors';
import { Spacing } from 'Themes/spacing';

import { PlayArrowIcon } from '@libs/shared/ui/icons';

interface ConnectIconButtonProps {
  isFreshStart?: boolean;
  isHighlighted?: boolean;
  disabled?: boolean;
}

export const ConnectIconButton = styled(IconButton)<ConnectIconButtonProps>`
  width: 52px;
  height: 52px;
  color: ${Colors.white};
  z-index: 1;
  transition: all 0.1s ease-in-out;
  background-color: ${({ isHighlighted }) => (isHighlighted ? Colors.red : Colors.white)};
  border: ${({ isHighlighted }) => (isHighlighted ? 'none' : `1px solid ${Colors.darkGrey}`)};

  ${({ isFreshStart }) =>
    isFreshStart &&
    `
      background-color: ${Colors.green};
    `}

  &:hover {
    background-color: ${Colors.blue};
    transition: all 0.1s ease-in-out;
    border: none;

    svg {
      color: ${Colors.white};
    }
  }

  + div p {
    font-weight: 700;
  }
`;

interface SecondaryButtonWrapperProps {
  disabled?: boolean;
  imitateButton?: boolean;
}

export const SecondaryButtonWrapper = styled('div')<SecondaryButtonWrapperProps>`
  border: 1px solid ${Colors.darkGrey};
  height: 38px;
  display: flex;
  padding-left: 25px;
  align-items: center;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  margin-left: 0 !important;
  transform: translate(-15px);

  ${({ disabled, imitateButton }) =>
    imitateButton &&
    !disabled &&
    `
      &:hover {
        cursor: pointer;
      }
    `}
`;

interface SecondaryButtonTextProps {
  disabled?: boolean;
}

export const SecondaryButtonText = styled(Typography)<SecondaryButtonTextProps>`
  padding-right: ${Spacing.small};
  font-weight: 700;
  color: ${Colors.textColor};

  ${({ disabled }) =>
    disabled &&
    `
      color: rgba(0, 0, 0, 0.26);
      pointer-events: none;
    `}
`;

interface PlayArrowIconProps {
  isFreshStart?: boolean;
  isHighlighted?: boolean;
}

export const StyledPlayArrowIcon = styled(PlayArrowIcon)<PlayArrowIconProps>`
  color: ${({ isHighlighted }) => (isHighlighted ? Colors.white : Colors.textColor)};

  &:hover {
    color: ${Colors.white};
  }

  ${({ isFreshStart }) =>
    isFreshStart &&
    `
      color: ${Colors.white};
    `}
`;
